import React from 'react';
import { useNavigation } from '../../components/hocs/withNavigation';
import { FooterSpecs, useFooter } from '../../states/FooterState';
import { NavigationSpecs } from '../../states/NavigationState';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';
import { PageForMyPageRenewal } from '../../components/atoms/applications/page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { AboutSection } from '../../components/atoms/sections/AboutSection';
import AboutSectionImage from './images/about-she-creators-section-image.png';
import SheCreatorsGuideImage from './images/she-creators-guide-image.png';
import SheCreatorsScheduleImage from './images/she-creators-schedule-image.png';
import BenefitsOfChallengingSheCreatorsImage from './images/benefits-of-challenging-she-creators-image.png';
import TypeOfSheCreatorsImage from './images/type-of-she-creators-image.png';
import { SquareButton } from '../../../commonv3/components/atoms/buttons/SquareButton';
import { PageSection } from '../../components/atoms/sections/PageSection';
import { PageSectionContent } from '../../components/atoms/sections/PageSectionContent';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import './sheCreatorsPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import {
  COMMMUNE_CHECK_COMPANY_JOB_PATH,
  COMMMUNE_CHECK_SNS_COMPE_PATH,
  COMMMUNE_CHECK_WRITER_COMPE_PATH,
  NOTION_CHECK_TYPE_OF_COMPANY_JOB_URL,
  NOTION_CHECK_TYPE_OF_SNS_JOB_URL,
  V3Routes,
  CommmuneRoute,
  COMMMUNE_SHE_CREATORS_SCHEDULE_PATH,
  NOTION_SHE_CREATORS_GUIDE_URL,
} from '../../routes/index';

const CheckJobButtonSection = () => {
  const { viewport } = GlobalStatesV3;
  return (
    <div styleName="check-job-button">
      <SquareButton
        id={'check-company-job-button'}
        loading={false}
        href={V3Routes.home(CommmuneRoute(COMMMUNE_CHECK_COMPANY_JOB_PATH)).stringify()}
        label="企業のお仕事案件を見る"
        buttonWidth={viewport.isSp ? '100%' : '310px'}
        target="_blank"
      />
      <SquareButton
        id={'check-sns-compe-button'}
        loading={false}
        href={V3Routes.home(CommmuneRoute(COMMMUNE_CHECK_SNS_COMPE_PATH)).stringify()}
        label={
          <>
            SHEのお仕事案件を見る
            <br />
            （SNSコンペ）
          </>
        }
        buttonWidth={viewport.isSp ? '100%' : '310px'}
        target="_blank"
      />
      <SquareButton
        id={'check-writer-compe-button'}
        loading={false}
        href={V3Routes.home(CommmuneRoute(COMMMUNE_CHECK_WRITER_COMPE_PATH)).stringify()}
        label={
          <>
            SHEのお仕事案件を見る
            <br />
            （ライターコンペ）
          </>
        }
        buttonWidth={viewport.isSp ? '100%' : '310px'}
        target="_blank"
      />
    </div>
  );
};

const MoreUseContent = () => {
  return (
    <div styleName="more-use-content">
      <a href={V3Routes.home(NOTION_SHE_CREATORS_GUIDE_URL).stringify()} target="_blank">
        <img styleName="more-use-content-image left-image" src={SheCreatorsGuideImage} />
      </a>
      <a href={V3Routes.home(CommmuneRoute(COMMMUNE_SHE_CREATORS_SCHEDULE_PATH)).stringify()} target="_blank">
        <img styleName="more-use-content-image right-image" src={SheCreatorsScheduleImage} />
      </a>
    </div>
  );
};

export const SheCreatorsPage = () => {
  restrictAccessForUser();
  useNavigation(NavigationSpecs.side());
  useFooter(FooterSpecs.likes());

  return (
    <PageForMyPageRenewal id="she-creators-page">
      <div styleName="she-creators-page-header">
        <BreadCrumb items={[{ text: 'お仕事案件' }]} hasHome />
        <PageHeader title="SHEcreators" testId="page-header-of-she-creators" />
      </div>
      <div styleName="she-creators-page-content">
        <AboutSection
          title="お仕事案件とは"
          description="SHElikesでは、企業のお仕事案件とSHEのコンペ案件を紹介しています。企業案件は、コンペや副業のお仕事、転職求人などいくつかの形式があります。また、SHEからの案件として、SHEの公式SNSに掲載されるクリエイティブやnoteのコンペがあります。学んだことを活かして挑戦してみましょう！"
          image={AboutSectionImage}
          color="pink"
        />
        <CheckJobButtonSection />
        <div styleName="she-creators-page-sections">
          <PageSection title="お仕事案件に挑戦するメリット">
            <PageSectionContent
              image={BenefitsOfChallengingSheCreatorsImage}
              body="お仕事案件に参加しているのは、未経験から挑戦している人ばかり！SHEからの紹介なので初めてのお仕事でも安心です。実務未経験でもOKな案件があったり、個人では獲得が難しいようなあっと驚く企業の案件もあります。一部コンペ案件では、採用されなくても作ったものを自主制作としてポートフォリオに掲載できるので、アウトプットの機会としてもご活用ください！"
            />
          </PageSection>
          <PageSection title="案件の種類">
            {/* TODO: hrefを更新する */}
            <PageSectionContent
              image={TypeOfSheCreatorsImage}
              body="企業からの案件とSHEからの案件があります。企業案件は、お仕事初心者の方でも気軽に参加できるコンペ形式に加えて、ポートフォリオでの応募選抜形式の副業・単発案件や転職求人があります。SHEからの案件では、SHEの公式SNSに掲載するクリエイティブのコンペとnoteのライターコンペがあります。詳細は以下のボタンからご確認ください。"
              buttonAttributes={[
                {
                  text: '企業案件の種類の詳細を見る',
                  href: V3Routes.home(NOTION_CHECK_TYPE_OF_COMPANY_JOB_URL).stringify(),
                },
                {
                  text: 'SHE案件の種類の詳細を見る',
                  href: V3Routes.home(NOTION_CHECK_TYPE_OF_SNS_JOB_URL).stringify(),
                },
              ]}
            />
          </PageSection>
          <PageSection title="お仕事案件をもっと活用しよう">
            <PageSectionContent body={<MoreUseContent />} />
          </PageSection>
        </div>
      </div>
    </PageForMyPageRenewal>
  );
};
